var TAKE_VALUE = 50;

var productOverview = {
  searchModel: {
    searchCriterias: [],
    sort: "",
    take: TAKE_VALUE,
    skip: 0,
    isProductSearch: true,

    itemNumbers: window.productItemNumbers ? window.productItemNumbers : [],
  },
  init: function () {
    this.filterBySector();
    this.sort();
    this.loadMoreProducts();
    this.initSearch();
    this.filter();
    this.productClick();
  },

  initSearch: function () {
    var searchModel = productOverview.searchModel;
    var queries = {};
    var skip = 0;
    var productId = undefined;
    $.each(document.location.search.substr(1).split("&"), function (c, q) {
      try {
        var i = q.split("=");
        var key = decodeURI(i[0].toString());
        var value = decodeURI(i[1].toString());
        if (key === "sort") {
          searchModel.sort = value;
          $("#orderBy .radio-select__trigger").text(value);
        } else if (key === "skip") {
          skip = value;
        } else if (key === "productId") {
          productId = value;
        } else {
          searchModel.searchCriterias.push({
            key: key,
            value: value.split(","),
          });
        }

        //var group = searchModel.searchCriterias.find(x => x.key === "Groups");
        var groups = [];
        searchModel.searchCriterias.forEach(function (item) {
          if (item.key === "Groups") {
            groups.push(item);
          }
        });
        if (groups !== undefined && groups[0].value.length > 0) {
          var groupId = groups[0].value[0];
          var sectionElem = $("#sectors a[data-id=" + groupId + "]");
          sectionElem.parent().addClass("selected");
          $("span.product-filter__header--primary").text(sectionElem.text());
          document.title = sectionElem.text() + " | Vikan";
        }
      } catch (err) {
        /*console.log("err");*/
      }
    });
    var selectedSector = $("#sectors .selected a");
    if (selectedSector.length) {
      searchModel.searchCriterias.push({
        key: "Groups",
        value: selectedSector.data("id"),
      });
      $("span.product-filter__header--primary").text(selectedSector.text());
    }
    var groups = [];
    searchModel.searchCriterias.forEach(function (item) {
      if (item.key === "Groups") {
        groups.push(item);
      }
    });
    if (groups === undefined) {
      $("#sectors li:first-child").addClass("selected");
    }
    searchModel.skip = 0;
    searchModel.take = skip * TAKE_VALUE + TAKE_VALUE;

    productOverview.search(productId);
    searchModel.skip = skip;
    searchModel.take = TAKE_VALUE;
    $(".product-grid__loading").hide();
  },
  productClick: function () {
    $("#product-grid").on("click", "a", function () {
      productOverview.generateSearchQuery($(this).attr("id"));
    });
  },

  generateSearchQuery: function (productId) {
    var searchCriterias = this.searchModel.searchCriterias;
    var sort = this.searchModel.sort;
    var skip = this.searchModel.skip;
    var query = [];
    if (sort !== "") {
      query.push("sort=" + sort);
    }
    if (skip !== 0) {
      query.push("skip=" + skip);
    }
    searchCriterias
      .filter(function (item) {
        return item.key !== "Groups";
      })
      .forEach(function (value) {
        query.push(value.key + "=" + value.value.join(","));
      });

    var groupName = "";
    if (
      $("#sectors .selected a") &&
      typeof $("#sectors .selected a").data("url") !== "undefined"
    ) {
      groupName = unescape($("#sectors .selected a").data("url"));
    }
    if (productId !== undefined) {
      query.push("productId=" + productId);
    }
    var basepath =
      "/" +
      window.location.pathname
        .split("/")
        .filter(function (x, index) {
          return index < 3 && x !== "";
        })
        .join("/") +
      "/";

    window.history.replaceState(
      null,
      null,
      basepath + groupName + (query.length > 0 ? "?" + query.join("&") : "")
    );
  },

  filter: function () {
    var toggleFilterValue = function (feature, facet, set) {
      var searchCriterias = productOverview.searchModel.searchCriterias;
      var index = searchCriterias.findIndex(function (search) {
        return search.key === feature;
      });
      if (set) {
        if (index === -1) {
          searchCriterias.push({ key: feature, value: [facet] });
        } else {
          searchCriterias[index].value.push(facet);
        }
      } else if (index !== -1) {
        var values = searchCriterias[index].value;
        //removes the feature if it only contains one element
        if (values.length === 1) {
          searchCriterias = searchCriterias.splice(index, 1);
        } else {
          //remove a single facet
          var facetIndex = values.indexOf(facet);
          if (facetIndex !== -1) {
            searchCriterias[index].value.splice(facetIndex, 1);
          }
        }
      }
      productOverview.searchModel.skip = 0;
      productOverview.search();
    };

    $("#filters").on(
      "change",
      "#product-filters .checkbox-select__item input[type=checkbox]",
      function () {
        var feature = $(this)
          .parents(".checkbox-select")
          .children()
          .first()
          .val();
        var facet = $(this).val();
        toggleFilterValue(feature, facet, this.checked);
      }
    );

    $("#filters").on(
      "click",
      ".product-filter__selected .product-filter__selected-filter",
      function () {
        var feature = $(this).data("feature");
        var facet = $(this).data("facet");
        toggleFilterValue(feature, facet, false);
      }
    );
  },

  filterBySector: function () {
    $("#sectors a").click(function () {
      var id = $(this).data("id");

      $(".nav-aside__item").removeClass("selected");
      $(this).parent(".nav-aside__item").addClass("selected");
      $("span.product-filter__header--primary").text($(this).text());
      document.title = $(this).text() + " | Vikan";
      var searchCriterias = [];
      productOverview.searchModel.searchCriterias = searchCriterias;
      if (id !== "") {
        var index = searchCriterias.findIndex(function (x) {
          x.key === "Groups";
        });
        if (index === -1) {
          searchCriterias.push({ key: "Groups", value: id });
        } else {
          searchCriterias[index].value = id;
        }
      }
      productOverview.searchModel.skip = 0;
      productOverview.search();
    });
    $("#mobile-sectors").on("click", "li", function () {
      var input = $(this).find("input");

      var id = input.val();
      var searchCriterias = [];
      productOverview.searchModel.searchCriterias = searchCriterias;
      if (id !== "") {
        searchCriterias.push({ value: [id], key: "Groups" });
      }
      productOverview.searchModel.skip = 0;
      productOverview.search();
    });
  },

  // Product Overview display specific products
  search: function (productId) {
    var openFilters = [];
    $("#product-filters .checkbox-select > input:checked").each(function () {
      openFilters.push($(this).attr("id"));
    });
    $.ajax({
      url: "/Umbraco/surface/ProductOverview/Search",
      type: "POST",
      data: productOverview.searchModel,
      dataType: "json",
    })
      .done(function (data) {
        if (data !== null) {
          $("#filters").html(data.filters);
          var initBase = false;
          if (productOverview.searchModel.skip === 0) {
            initBase = true;
            $("#product-grid").html(data.productResultHtml);
          } else {
            initBase = true;
            $("#product-grid").append(data.productResultHtml);
          }
          if (initBase) {
            setTimeout(function () {
              bannerMaster.init();
            }, 10);
          }

          if (data.gridbanner !== null) {
            $(".grid-row-banner").remove();

            var shownProductsCount = $(".product-grid > a").length;
            //Create array of elements to insert
            const elementsToInsert = [];
            for (var i = 0; i < data.gridbannerIndex.length; i++) 
            {
              const element = {index : data.gridbannerIndex[i], html : data.gridbanner[i]};
              elementsToInsert.push(element)
            }
            elementsToInsert.sort((a, b) => b.index - a.index);
            //Insert elements
            for (var i = 0; i < elementsToInsert.length; i++) 
            {
              var element = elementsToInsert[i];
              if(element.index <= shownProductsCount-1){
                var productElement = $(".product-grid > a").eq(element.index);
                $(element.html).insertBefore(productElement);
              }
              else{
                if(shownProductsCount === data.totalProducts){
                  var productElement = $(".product-grid > a").last();
                  $(element.html).insertAfter(productElement);
                }
              }
            }
          }

          $("#top-content").html(data.top === null ? "" : data.top);
          $("#bottom-content").html(data.bottom === null ? "" : data.bottom);
          $("#product-filter-count").text(data.totalProducts);

          if ($(".product-grid > a").length === data.totalProducts) {
            $("#load-more").hide();
          } else {
            $("#load-more").show();
          }
          $("#load-more").removeClass("loading");
          if (productId) {
            //scroll to product
            $("html, body").animate(
              {
                scrollTop:
                  $("#" + productId)
                    .children(":first")
                    .offset().top - 150,
              },
              1000
            );
            $("div#element").scrollTop(localStorage.getItem("scrollPosition"));
          }

          productOverview.generateSearchQuery();

          openFilters.forEach(function (item) {
            $("#" + item).prop("checked", true);
          });
        } else {
          $("#load-more").hide();
        }
      })
      .fail(function (error) {});
  },

  sort: function () {
    $("#orderBy .radio-select__label").click(function () {
      var $current = $(this);
      var sortData = $current.data("sort-id");
      productOverview.searchModel.sort = sortData;
      productOverview.searchModel.skip = 0;
      productOverview.search();
    });
  },

  loadMoreProducts: function () {
    $("#load-more").click(function () {
      productOverview.searchModel.skip++;
      productOverview.search();
      $(this).addClass("loading");
    });
  },

  startSearch: function () {
    if (unescape(window.location.href.indexOf("?")) > 0) {
      var loadedArray = unescape(window.location.href.split("?").pop());
      var data = JSON.parse(loadedArray.replace("#", ""));
      if (data[0].key && data[0].key === "Groups") {
        $("a[data-id=" + data[0].value + "]").trigger("click");
      }
    }
  },
};

$(document).ready(function () {
  if ($("#page-product-overview").length > 0) {
    productOverview.init();
  }
});
